import Details from './Details';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../actions';

const mapStateToProps = state => {
  const {
    reportName,
    reportDescription
  } = state.reports;
  return {
    reportName,
    reportDescription
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Details);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Details/DetailsContainer.js